import Vue from 'vue'
import Vuex from 'vuex'
import { authentication } from '@/store/auth.store'
import { alert } from '@/store/alert.module'
import { TrxPembelian } from '@/store/trxpembelian.store'
import { ProductMapping } from '@/store/productmapping.store'
import { ProductStore } from '@/store/product.store'
import { SaldoStore } from '@/store/saldo.store'
import { AdmStore } from '@/store/adm.store'
import { PublicStore } from '@/store/public.store'
import { UserStore } from '@/store/user.store'
import { UtilsStore } from '@/store/utils.store'
import { SellerStore } from '@/store/seller.store'
import { AdminUserStore } from '@/store/admuser.store'
import { ReviewStore } from '@/store/review.store'
import { TrxAdmin } from '@/store/admin.trx.store'
import { FeedStore } from '@/store/feed.store'
import { AdminBankStore } from '@/store/admin.bank.store'
import { AdminSliders } from '@/store/admin.slider.store'
import { AdminProducts } from '@/store/admin.product.store'
import { ChatStore } from '@/store/chat.store'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
    SOCKET_needlogon ({ dispatch, commit }, message) {
      console.log('NeedLogon')
      console.log(message)
    },
    SOCKET_chatnotif ({ dispatch, commit }, message) {
      // dispatch('LogStore/addlog', message, { root: true })
      dispatch('alert/success', message.msg, { root: true })
      dispatch('ChatStore/getMessages', message.groupid, { root: true })
    }
  },
  modules: {
    FeedStore,
    authentication,
    alert,
    TrxPembelian,
    ProductMapping,
    ProductStore,
    SaldoStore,
    AdmStore,
    PublicStore,
    UserStore,
    UtilsStore,
    SellerStore,
    AdminUserStore,
    ReviewStore,
    TrxAdmin,
    AdminBankStore,
    AdminSliders,
    AdminProducts,
    ChatStore
  }
})
